import { render, staticRenderFns } from "./gallery-folder-list.vue?vue&type=template&id=e3170c3e&"
import script from "./gallery-folder-list.vue?vue&type=script&lang=ts&"
export * from "./gallery-folder-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports